const createAction = (storeName, type, payload) => ({
    type: `${storeName.toUpperCase()}.${type}`,
    payload,
});

const getPage = (storeName, data) => createAction(storeName, 'GET_PAGE', data);
const addOneMorePage = (storeName, data) => createAction(storeName, 'ADD_ONE_MORE_PAGE', data);
const setPageSize = (storeName, size) => createAction(storeName, 'SET_PAGE_SIZE', size);
const addPageForOfflineOrders = (storeName, data) =>
    createAction(storeName, 'ADD_ONE_MORE_PAGE_OFFLINE', data);

export default {
    getPage,
    addOneMorePage,
    setPageSize,
    addPageForOfflineOrders,
};
